import { useTranslation } from 'react-i18next';
import { cn } from '../../../lib/utils';
import type { StatusBadgeProps } from '../types';

const STATUS_COLORS: Record<string, string> = {
  // Order statuses
  OPEN: 'bg-green-100 text-green-700',
  IN_REVIEW: 'bg-yellow-100 text-yellow-700',
  CONTRACTED: 'bg-blue-100 text-blue-700',
  IN_PROGRESS: 'bg-purple-100 text-purple-700',
  COMPLETED: 'bg-gray-100 text-gray-700',
  CANCELLED: 'bg-red-100 text-red-700',
  ARCHIVED: 'bg-slate-100 text-slate-700',
  // Proposal statuses
  PENDING: 'bg-yellow-100 text-yellow-700',
  ACCEPTED: 'bg-green-100 text-green-700',
  REJECTED: 'bg-red-100 text-red-700',
  WITHDRAWN: 'bg-gray-100 text-gray-700',
};

const ORDER_STATUSES = new Set(['OPEN', 'IN_REVIEW', 'CONTRACTED', 'IN_PROGRESS', 'COMPLETED', 'CANCELLED', 'ARCHIVED']);

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const { t } = useTranslation();
  const color = STATUS_COLORS[status] || 'bg-gray-100 text-gray-700';

  const label = ORDER_STATUSES.has(status)
    ? t(`common.orderStatus.${status}`)
    : t(`common.proposalStatus.${status}`, status);

  return (
    <span className={cn('px-2 py-1 rounded-full text-xs font-medium', color, className)}>
      {label}
    </span>
  );
}
